import { useState, useEffect } from "react";
import moment from "moment";
import InputDate from "../../components/form/InputDate";
import Select from "../../components/form/select/Select";
import ModalDefault from "../../components/ModalDefault";
import api from "../../services/api";
import message from "../../services/message";
import axios from "axios";
import { Container } from "../../styles/layout";
import {
  IconAdd,
  IconArrow,
  IconDetails,
  IconEdit,
  IconFilter,
  IconRemove,
} from "../../components/layout/Svgs";

import {
  HeaderPonto,
  SectionFilterPonto,
  SectionTablePonto,
  SectionDetailsPonto,
  SectionRegisterPonto,
  ContainerPonto,
} from "./styles";
import ButtonDownload from "../../components/form/ButtonDownload/ButtonDownload";
import { ContainerModal, SectionModal } from "../../components/layout/styles";
import Input from "../../components/form/input/Input";





export default function DespesasListar() {

  const [load, setLoad] = useState(false);
  const [modal, setModal] = useState(false);

  const [despesas, setDespesas] = useState([])
  const [newDespesa, setNewDespesa] = useState({
    despesaId:null,
    nome:'',
    descricao:'',
    status:'ativo'
  })

  useEffect(() => {
    getDespesas()
  }, [])

  async function getDespesas(){
    try{
      let response : any =  await api.get(`/despesa`)
      setDespesas(response.data)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function resetDespesa(){
    setNewDespesa({
        despesaId:null,
        nome:'',
        descricao:'',
        status:'ativo'
    })

    setModal(!modal)
  }

  function handleOnChangeNewDespesa(name: string, value: string) {
    if (value) {
      setNewDespesa({ ...newDespesa, [name]: value });
    } else {
      setNewDespesa({ ...newDespesa, [name]: ''});
    }
  }

  async function editarDespesa(id?: any) {
    

    try{
      if(id){
        let response = await api.get(`/despesa/${id}`)
        setNewDespesa(response.data)
      }else{
        resetDespesa()
      }
      
      setModal(true);
    } catch(error: any) {
      message.error(String(error?.response?.data?.message));
    }
  }

  async function saveDespesa(e:any){
    try{
      e.preventDefault();
      let response : any
      if(newDespesa.despesaId){
        response = await api.put(`/despesa/${newDespesa.despesaId}`,newDespesa)
        message.success(`Despesa Editada com Sucesso.`)
      }else{
        response = await api.post(`/despesa`, newDespesa)
        message.success(`Despesa Criada com sucesso`)
      }
      await getDespesas()
      resetDespesa()
      setModal(!modal)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function excluirDespesa(id:number){
    try{
      let response : any = await api.delete(`/despesa/${id}`)
      getDespesas()

      message.success(`Despesa Excluida com Sucesso.`)
    
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }



  return (
    <Container>
      <HeaderPonto>
        <h1 className="titlePonto">Despesas</h1>
        <button
          style={{ margin: "0px", width: "100px", letterSpacing: "1px",verticalAlign:'middle' }}
          className="btn btn-primary"
          onClick={() => editarDespesa()}
        > 
          Adicionar 
          <i className="fa-solid fa-plus"></i>
        </button>
      </HeaderPonto>

      <SectionTablePonto>
        <table className="default">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Descrição</th>
              <th>Editar</th>
              <th>Remover</th>
              
            </tr>
          </thead>

          <tbody>

            { despesas && despesas.length > 0 &&
              despesas.map((row:any, key:any) =>(
                <tr key={''}>
          
                  <td>{row.nome}</td>
                  <td>{row.descricao}</td>
                  <td>
                    <button
                      className="btn"
                      onClick={() => editarDespesa(row.despesaId)}
                    >
                      <IconEdit />
                    </button>
                  </td>
                  <td>
                    <button
                      className="btn"
                      onClick={() => excluirDespesa(row.despesaId)}
                    >
                      <IconRemove />
                    </button>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </SectionTablePonto>
      <ModalDefault
        id="modalDefault"
        onClose={() => resetDespesa()}
        visible={modal}
      >
        <ContainerModal>
          <SectionModal>
            <h1>Editar / Adicionar - Despesa</h1>
            <form onSubmit={saveDespesa}>
              <div className="field">
                <h4>Nome</h4>
                <div className="input">
                  <Input type="text" name="nome" value={newDespesa?.nome} onChange={handleOnChangeNewDespesa}/>
                </div>
              </div>
              <div className="field">
                <h4>Descrição</h4>
                <div className="input">
                  <Input type="text" name="descricao" value={newDespesa?.descricao} onChange={handleOnChangeNewDespesa}/>
                </div>
              </div>

              <div className="actions">
                <button type="submit" className="btn btn-success">Salvar</button>
                <button type="button" onClick={() => setModal(!modal)} className="btn btn-danger">Voltar</button>
              </div>
            </form>
            
          </SectionModal>
            <button
              className="buttonClosePreview"
              onClick={() => resetDespesa()}
            >
              <IconRemove width="22px" height="22px" />
              Fechar modal
            </button>
          
        </ContainerModal>

      </ModalDefault>
    </Container>
  );
}
